import React from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import { TIPS } from 'src/utils/constants';

import CardItem from '../../Common/card';

const Container = styled.div`
  width: 100%;
  max-width: 370px;
  .slick-next {
    right: 5px !important;
    &:before {
      color: black !important;
    }
  }
  .slick-prev {
    left: 5px !important;
    z-index: 999;
    &:before {
      color: black !important;
    }
  }
`;
const CardContent = styled.div`
  width: 100%;
`;
const TipContainer = styled.div`
  display: flex !important;
  flex-direction: column;
  align-items: center;
  padding: 0 25px;
  font-size: 13px;
  line-height: 2;
  text-align: center;
  outline: none;
`;
const TipHeader = styled.h3`
  margin: 0;
`;
const TipText = styled.p`
  margin: 0;
`;

const MainSliderSettings = {
  arrows: true,
  dots: false,
  infinite: true,
  speed: 500,
  autoplay: true,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const Tips = () => {
  return (
    <Container title="Safety Tips">
      <CardItem title="Tips">
        <CardContent>
          <Slider {...MainSliderSettings}>
            {TIPS.map((text, index) => {
              return (
                <TipContainer key={index}>
                  <TipHeader>{`TIP # ${index + 1}:`}</TipHeader>
                  <TipText>{text}</TipText>
                </TipContainer>
              );
            })}
          </Slider>
        </CardContent>
      </CardItem>
    </Container>
  );
};

export default Tips;
